// Import necessary dependencies
import React from "react";
import styled from "styled-components";

// Create a styled input component
const StyledInput = styled.input`
	width: 100%;
	padding: 10px;
	font-size: 16px;
	margin-bottom: 10px;
	box-sizing: border-box;
	transition: all 100ms ease 0s;
	background-color: rgb(255, 255, 255);
	border-color: rgb(204, 204, 204);
	border-radius: 4px;
	border-style: solid;
	border-width: 1px;
	outline: 0px !important;
	opacity: 1;

	&:focus {
		border-color: #aacefa; /* Change border color when in focus */
		outline: none; /* Remove default focus outline (optional) */
	}
`;

const FormGroup = styled.div`
	margin-bottom: 15px;
`;

const Label = styled.label`
	margin-bottom: 5px;
`;

const InputBox = (props) => {
	return (
		<FormGroup>
			<Label htmlFor={props.label}>{props.label}</Label>
			<StyledInput
				type={props.type}
				name={props.name}
				id={props.id}
				value={props.value}
				onChange={props.handleChange}
				accept={props.accept}
				disabled={props.disabled}
				min={props.min}
			/>
			{props.errors.hasOwnProperty(props.name) && (
				<span style={{ color: "red" }}>{props.errors[props.name]}</span>
			)}
		</FormGroup>
	);
};

export default InputBox;
